var render = function (_h,_vm) {var _c=_vm._c;return _c('i',{staticClass:"doc-icon",class:[_vm.props.iconName? ("doc-icon_" + (_vm.props.iconName)) : '', _vm.props.iconTheme? ("doc-icon_theme-" + (_vm.props.iconTheme)) : '', _vm.props.iconSize? ("doc-icon_size-" + (_vm.props.iconSize)) : '', _vm.data.staticClass, _vm.data.class]})}
var staticRenderFns = []

export { render, staticRenderFns }